export const REGISTER_PAGE_URL = `https://www.gettimely.com/signup/`;
export const CALENDAR_PAGE_URL = `https://app.gettimely.com/calendar/`;

// This path will eventually need to be changed to point at an updated API endpoint, however I am making that a future problem for the timebeing.
export const OLSON_TIMEZONE_API_URL = `https://app.gettimely.com/register/GetTimeZoneIdByOlsonName`;
